/**
 * Reviews Adapter
 *
 * This adapter provides utility functions for identifying the data format
 * so that appropriate components can be used to display the data.
 */

/**
 * Determines if the data is in the new v2 format
 * @param {Object} data - The review analysis data
 * @returns {Boolean} - True if the data is in v2 format
 */
export const isV2Format = (data) => {
  // Check for v2 specific properties
  return Boolean(
    data &&
    (data.version === '2.0' ||
      data.review_analysis_results?.negative_issues ||
      data.review_analysis_results?.overall_summary ||
      data.review_analysis_results?.product_aspects ||
      data.review_analysis_results?.delight_features ||
      data.review_analysis_results?.thematic_clusters)
  );
};

/**
 * Checks which components should be used to render the data
 * @param {Object} reviewsState - The state from the reviewsReducer
 * @returns {String} - 'v1' or 'v2' indicating which components to use
 */
export const getDataVersion = (reviewsState) => {
  return reviewsState.dataVersion || null;
};

/**
 * Gets the appropriate data from the state based on format
 * @param {Object} reviewsState - The state from the reviewsReducer
 * @returns {Object} - The data in its original format
 */
export const getReviewsData = (reviewsState) => {
  return reviewsState.dataVersion === 'v2' ? reviewsState.v2Data : reviewsState.analysisData;
};

export default {
  isV2Format,
  getDataVersion,
  getReviewsData
};
